import React, { useState, useRef, useEffect } from "react";
import "./Accordion.css";
import ReactHtmlParser from "html-react-parser";

const Accordion = ({ accordionData }) => {
  const [activeIndexes, setActiveIndexes] = useState([]);

  const toggleAccordion = (tier, index) => {
    setActiveIndexes((prevIndexes) => {
      const newIndexes = [...prevIndexes];
      newIndexes[tier] = newIndexes[tier] === index ? null : index;
      return newIndexes;
    });
  };

  return (
    <div className="accordion">
      {accordionData.map((item, index) => (
        <NestedAccordionItem
          key={index}
          item={item}
          index={index}
          tier={0}
          activeIndexes={activeIndexes}
          toggleAccordion={toggleAccordion}
        />
      ))}
    </div>
  );
};

export default Accordion;

const NestedAccordionItem = ({
  item,
  index,
  tier,
  activeIndexes,
  toggleAccordion,
}) => {
  const isExpanded = activeIndexes[tier] === index;
  const headerRef = useRef(null);

  useEffect(() => {
    if (isExpanded && headerRef.current) {
      headerRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [isExpanded]);

  return (
    <div
      className={`accordion-item ${isExpanded ? "expanded" : ""}`}
      key={index}
    >
      <div
        className={`accordion-header ${isExpanded ? "expanded" : ""}`}
        ref={headerRef}
        onClick={() => toggleAccordion(tier, index)}
      >
        <h3>{item.attributes.tab_name}</h3>
        <span className="icon"></span>
      </div>
      {isExpanded && (
        <div className="accordion-content">
          {item.attributes.tab_detail &&
            ReactHtmlParser(item.attributes.tab_detail)}
          {item.attributes.media_url && (
            <div className="media_embedded">
              <iframe
                title="Media"
                width="100%"
                height="100%"
                src={item.attributes.media_url}
              ></iframe>
            </div>
          )}
          {item.attributes.service_nested_accordions &&
            item.attributes.service_nested_accordions.data.length !== 0 && (
              <div className="nested-accordion">
                {item.attributes.service_nested_accordions.data.map(
                  (subItem, subIndex) => (
                    <NestedAccordionItem
                      key={subIndex}
                      item={subItem}
                      index={subIndex}
                      tier={tier + 1}
                      activeIndexes={activeIndexes}
                      toggleAccordion={toggleAccordion}
                    />
                  )
                )}
              </div>
            )}
        </div>
      )}
    </div>
  );
};
